/* Bright Solar Lights — category dropdown on the Range section.
   Swaps the product grid in place: All / Solar Lights / CCTV / Solar Fans.
   Products come live from Shopify so the grid never goes stale.

   "Solar Lights" points at the solar-lights collection, not street-lights.
   street-lights is tag-driven and only ever held the street lights, so the
   garden lamp, ceiling light, wall light and flood light were all missing
   from a category called Solar Lights. solar-lights is rule-driven on
   product type and picks up every light in the catalogue.

   The homepage is a React app that re-renders this grid and rewrites the
   class attribute on its cards, so hiding the built-in cards with a class
   does not survive. Instead a data attribute is set on #range — which React
   does not own — and CSS hides everything that is not one of ours. */
(function () {
  var STYLE_ID = "bsl-rf-style-v3";
  var GOLD = "#F5A800";
  var INK = "#171A15";
  var MIST = "#EEF0EB";
  var MUTED = "#6E7268";

  var CATS = [
    { label: "All products", handle: "" },
    { label: "Solar Lights", handle: "solar-lights" },
    { label: "CCTV", handle: "cctv" },
    { label: "Solar Fans", handle: "solar-fans" }
  ];

  var current = "";
  var cache = {};
  var rendered = "";

  function styles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = [
      ".bsl-rf{display:flex;align-items:center;gap:.7rem;margin-top:1.4rem;flex-wrap:wrap}",
      ".bsl-rf label{font-family:'JetBrains Mono',ui-monospace,monospace;font-size:.7rem;" +
        "letter-spacing:.14em;text-transform:uppercase;color:" + MUTED + "}",
      ".bsl-rf select{appearance:none;-webkit-appearance:none;background-color:#fff;" +
        "border:1px solid rgba(23,26,21,.16);border-radius:999px;" +
        "padding:.6rem 2.4rem .6rem 1.1rem;font-family:Inter,system-ui,sans-serif;" +
        "font-size:.88rem;font-weight:600;color:" + INK + ";cursor:pointer;" +
        "background-image:url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' " +
        "viewBox='0 0 24 24' fill='none' stroke='%23171A15' stroke-width='2' stroke-linecap='round' " +
        "stroke-linejoin='round'><path d='m6 9 6 6 6-6'/></svg>\");" +
        "background-repeat:no-repeat;background-position:right .85rem center;background-size:15px}",
      ".bsl-rf select:focus{outline:2px solid " + GOLD + ";outline-offset:2px}",
      ".bsl-rf-count{font-size:.8rem;color:" + MUTED + "}",

      /* when a category is chosen, only our cards show */
      "#range[data-bsl-cat] .bsl-grid > *:not(.bsl-rf-card):not(.bsl-rf-empty){display:none !important}",

      ".bsl-rf-ph{width:100%;height:100%;display:flex;align-items:center;justify-content:center;" +
        "background:" + MIST + ";color:rgba(23,26,21,.22)}",
      ".bsl-rf-empty{grid-column:1/-1;padding:2.5rem 1rem;text-align:center;" +
        "font-family:Inter,system-ui,sans-serif;color:" + MUTED + "}"
    ].join("");
    document.head.appendChild(s);
  }

  function money(v) {
    var n = parseFloat(v);
    return isNaN(n) ? "" : "£" + n.toFixed(2);
  }

  function placeholder() {
    return (
      '<div class="bsl-rf-ph"><svg viewBox="0 0 24 24" width="46" height="46" fill="none" ' +
      'stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M9 18h6"/><path d="M10 21h4"/>' +
      '<path d="M12 3a6 6 0 0 0-3.5 10.9c.6.5.9 1.2.9 1.9v.2h5.2v-.2c0-.7.3-1.4.9-1.9A6 6 0 0 0 12 3Z"/>' +
      "</svg></div>"
    );
  }

  function card(p) {
    var v = (p.variants && p.variants[0]) || {};
    var img = p.images && p.images[0] && p.images[0].src;
    var sale = v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price);
    var title = (p.title || "").replace(/"/g, "");

    return (
      '<article class="bsl-card bsl-rf-card" data-bsl-card="2">' +
        (sale ? '<div class="bsl-badgerow"><span>Sale</span></div>' : "") +
        '<div class="bsl-well">' +
          (img
            ? '<img src="' + img + '" alt="' + title + '" loading="lazy" decoding="async">'
            : placeholder()) +
        "</div>" +
        "<h3>" + (p.title || "") + "</h3>" +
        '<div class="bsl-sub">' + (p.product_type || "Solar powered · no wiring") + "</div>" +
        '<div class="bsl-buy">' +
          "<span>" + money(v.price) + "</span>" +
          (sale ? '<span class="line-through">' + money(v.compare_at_price) + "</span>" : "") +
          '<a href="/products/' + p.handle + '" data-vid="' + (v.id || "") + '" ' +
            'class="bsl-rf-add">Add to basket</a>' +
        "</div>" +
      "</article>"
    );
  }

  function wireAdd(g) {
    var links = g.querySelectorAll("a.bsl-rf-add");
    for (var i = 0; i < links.length; i++) {
      (function (a) {
        if (a.dataset.bound) return;
        a.dataset.bound = "1";
        a.addEventListener("click", function (e) {
          var id = a.getAttribute("data-vid");
          if (!id) return;
          e.preventDefault();
          var label = a.textContent;
          a.textContent = "Adding…";
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          })
            .then(function (r) { return r.json(); })
            .then(function () {
              a.textContent = "Added ✓";
              document.dispatchEvent(new CustomEvent("bsl:cart-updated"));
              setTimeout(function () { a.textContent = label; }, 1600);
            })
            .catch(function () { a.textContent = label; });
        });
      })(links[i]);
    }
  }

  function section() { return document.getElementById("range"); }
  function grid() {
    var r = section();
    return r ? r.querySelector(".bsl-grid") : null;
  }

  function clearMine(g) {
    var mine = g.querySelectorAll(".bsl-rf-card, .bsl-rf-empty");
    for (var i = 0; i < mine.length; i++) mine[i].remove();
  }

  /* keep our cards on screen even when React re-renders the grid */
  function assert() {
    var sec = section(), g = grid();
    if (!sec || !g) return;

    if (!current) {
      delete sec.dataset.bslCat;
      clearMine(g);
      return;
    }

    sec.dataset.bslCat = current;
    if (!g.querySelector(".bsl-rf-card, .bsl-rf-empty") && rendered) {
      g.insertAdjacentHTML("beforeend", rendered);
      wireAdd(g);
    }
  }

  function load(handle, countEl) {
    current = handle;

    if (!handle) {
      rendered = "";
      if (countEl) countEl.textContent = "";
      assert();
      return;
    }

    function paint(products) {
      rendered = products.length
        ? products.map(card).join("")
        : '<p class="bsl-rf-empty">Nothing in this category yet — check back soon.</p>';
      var g = grid();
      if (g) clearMine(g);
      assert();
      if (countEl) {
        countEl.textContent = products.length
          ? products.length + " product" + (products.length === 1 ? "" : "s")
          : "";
      }
    }

    if (cache[handle]) { paint(cache[handle]); return; }

    if (countEl) countEl.textContent = "loading…";
    fetch("/collections/" + handle + "/products.json?limit=50")
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var products = j.products || [];
        cache[handle] = products;
        paint(products);
      })
      .catch(function () {
        rendered = '<p class="bsl-rf-empty">Couldn’t load that category. Please try again.</p>';
        var g = grid();
        if (g) clearMine(g);
        assert();
        if (countEl) countEl.textContent = "";
      });
  }

  function place() {
    var sec = section();
    if (!sec) return;
    var g = grid();
    if (!g) return;

    if (!sec.querySelector(".bsl-rf")) {
      var wrap = document.createElement("div");
      wrap.className = "bsl-rf";
      wrap.innerHTML =
        '<label for="bsl-rf-select">Browse</label>' +
        '<select id="bsl-rf-select">' +
          CATS.map(function (c) {
            return '<option value="' + c.handle + '">' + c.label + "</option>";
          }).join("") +
        "</select>" +
        '<span class="bsl-rf-count"></span>';
      g.parentNode.insertBefore(wrap, g);

      var sel = wrap.querySelector("select");
      var countEl = wrap.querySelector(".bsl-rf-count");
      sel.value = current;
      sel.addEventListener("change", function () { load(sel.value, countEl); });
    }

    assert();
  }

  function run() { styles(); place(); }

  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);
})();
